import { render, staticRenderFns } from "./UploadCmp.vue?vue&type=template&id=69d1ddcb"
import script from "./UploadCmp.vue?vue&type=script&lang=js"
export * from "./UploadCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d1ddcb')) {
      api.createRecord('69d1ddcb', component.options)
    } else {
      api.reload('69d1ddcb', component.options)
    }
    module.hot.accept("./UploadCmp.vue?vue&type=template&id=69d1ddcb", function () {
      api.rerender('69d1ddcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimStatement/cmp/UploadCmp.vue"
export default component.exports